import {Concept} from 'types';
import type {Agent, AgentPublisher} from 'api/types';

export const isAgentPublisher = (value: unknown): value is AgentPublisher =>
  typeof value === 'object' && (value as Agent).agentType === Concept.publisher;
